// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__5VZe4","primary":"Button_primary__ejCmb"};